import { Summary } from './summary.js';
import { Payment } from './payment.js';
import { Input } from './input.js';
import { Product } from './product.js';
export { Order } from './order.js';
import '../uploader.js';
import { Voucher } from './voucher.js';
import { Login } from './login.js';
import { PVAWidget } from './pvawidget.js';

export class Landingpage {
    constructor(hasBonus = 0, hasAddon = 0, hasUpsell = 0, maxSteps = 0) {
        this.summary = null;
        this.payment = null;
        this.input   = null;
        this.product = null;
        this.pvawidget = null;

        this.offer = false;
        this.bonus = false;
        this.addon = false;
        this.upsell = false;

        this.maxSteps = maxSteps;
        this.hasBonus = !!hasBonus;
        this.hasAddon = !!hasAddon;
        this.hasUpsell = !!hasUpsell;

        this.form = document.querySelector('#form-landingpage');
        this.formFields = document.querySelector('.formfields');
        this.needCustomerId = document.querySelector('.ce.customerid');
        this.noOffer = document.querySelectorAll('.ce.nooffer');
        this.code = document.querySelector('input[name="landingpage[code]"]');
        this.hasVoucher = document.querySelector('input[name="landingpage[voucher]"]');

        this.showLogin = document.querySelector('.ce.loginregister');

        this.deliveryStart = document.querySelector('input[name="order[deliveryStart]"]');
        this.deliveryStartHolder = document.querySelector('#deliverystart-holder');
        this.deliveryStartFallback = document.querySelector('#deliverystart-fallback');
        this.deliveryStartTitle = document.querySelector('#deliverystart-title');
        this.deliveryStartTouched = false;
        
        this.init();
    };

    init() {
        this.globalInit();
        
        this.form.addEventListener('submit', event => {
            event.preventDefault();
            if (this.needCustomerId) {
                this.submitCustomerId();
            }
            if (this.code) {
                this.submitLandingpageCode();
            } else {
                this.submitLandingpage();
            }
        });
        
        if (this.needCustomerId || this.noOffer.length || this.code) {
            return false;
        }

        if (this.hasVoucher) {
            this.voucher = new Voucher(this.showLogin);
        }

        if (this.showLogin) {
            this.login = new Login();
        }

        this.pvawidget = new PVAWidget();

        this.summary = new Summary();
        this.summaryEvents();

        this.input = new Input();
        this.inputEvents();

        this.payment = new Payment();
        this.paymentEvents();

        this.product = new Product();
        this.productEvents();
        this.product.checkStartOffer();

        this.pvawidget.singleCheck()

        this.updatePva();
        this.payment.updateReportingPrice();
    };
    
    submitLandingpage() {
        if (this.payment.clearingType.value == 'creditcard' && !this.payment.isValidated) {
            this.payment.Payone.checkCreditCard();
            return false;
        }
        this.payment.updateReportingPrice();
        let request = new Request('POST', this.form.getAttribute('action'));
        request.formData = this.form;
        request.call(response => {
            if(response.status == 'ok' || response.status == 'redirect') {
                this.#submitLandingpageSuccess(response);
            } else {
                this.#submitLandingpageError(response);
            }
        });
    };

    #submitLandingpageSuccess(response) {
        OVS.app.helper.toggleButton(true);
        if(response.status == 'ok' || OVS.app.helper.isOm) {
            Tracking.customEvent('checkout_submit', {
                product_name: this.offer.drerz,
                product_has_device: (this.bonus) ? this.bonus.isDevice : false,
                product_device_name: (this.bonus) ? (this.bonus.title + ' ' + this.bonus.text) : '',
                event_category: 'checkout',
                event_action: 'submit',
                event_label: this.offer.title,
                event_type: this.payment.paymentType,
                step: this.getEventStep('submit'),
                maxStep: this.maxSteps,
                prefilled: OVS.app.user.isUser,
                payment_type: this.payment.clearingType.value ?? '',
                order_id: response.order_id ?? '',
            });

            if (OVS.app.helper.isOm) {
                    window.drive('trackSelfDescribingEvent', {
                        schema: 'iglu:de.drive/subscription_context/jsonschema/1-0-0',
                        data: {
                            action: 'conversion',
                            label: 'thankyou-page',
                            product: this.offer.title,
                            price: '',
                            payment_method: this.payment.paymentType,
                        }
                    });
                }
        }
        Cookies.remove('ovs_selected_offer', { expires: 365, secure: false, domain: OVS.app.user.cookieDomain });
        window.location = response.redirect;
    };

    #submitLandingpageError(response) {
        let scrollToElement = false;
        Object.entries(response.fields).forEach(entry => {
            const [key, field] = entry;
            this.input.updateFieldStatus(key, field.valid, field.value);
            if(!scrollToElement && !field.valid) {
                scrollToElement = (key == 'order[product]') ? '.offers' : 'input[name*="' + key + '"]';
            }
        });

        if(scrollToElement) {
            OVS.app.helper.scrollTo(scrollToElement, true, 0);
        }
    };
    
    submitLandingpageCode() {
        let request = new Request('POST', this.form.getAttribute('action') + '/code');
        request.data = {
            code: this.code.value,
        };

        request.call(data => {
            if(data.status == 'ok') {
                window.location.href = document.location.pathname;
            } else {
                OVS.app.helper.removeClass('.error', 'd-none');
            }
        });
    };
    
    submitCustomerId() {
        let request = new Request('POST', this.form.getAttribute('action'));
       
        let kundennummer = (document.querySelector('input[name="landingpage[customerId]"]') !== null) ? document.querySelector('input[name="landingpage[customerId]"]').value : false;
        let anrede = (document.querySelector('select[name="landingpage[anrede]"]')) ? document.querySelector('select[name="landingpage[anrede]"]').value : false
        let vorname =  (document.querySelector('input[name="landingpage[vorname]"]') !== null) ? document.querySelector('input[name="landingpage[vorname]"]').value : false;
        let nachname = (document.querySelector('input[name="landingpage[nachname]"]') !== null) ? document.querySelector('input[name="landingpage[nachname]"]').value : false;
        
        request.data = {
            customerId: kundennummer,
            salutation: anrede,
            firstName: vorname,
            lastName: nachname
        };
        
        request.call(data => {
            if(data.status == 'ok') {
               location.reload();
            } else {
                OVS.app.helper.removeClass('.error', 'd-none');
                document.querySelector('.error').innerHTML =  data.message;
                return false;
            }
        });
    };

    updatePva() {
        if(this.pvawidget.price) {
            this.summary.updatePriceOffer(this.pvawidget.price, true);
        }
        
        if(this.pvawidget.device) {
            this.summary.updatePriceDevice(this.pvawidget.device, true);
        }

        if(this.pvawidget.mandant == 'beig') {
            let options = this.offer.payments;
            options = options.filter(o => o !== 'paypal');
            options = options.filter(o => o !== 'creditcard');
            this.payment.updatePaymentOptions(options);
            if(this.payment.selectedOption.type == 'paypal' || this.payment.selectedOption.type == 'creditcard') {
                this.payment.selectFirstPayment();
            }
        } else {
            this.payment.updatePaymentOptions(this.offer.payments);
        }
        this.summary.updateAusgabe(this.pvawidget.title);
    };

    enableNextStep(formReady = false) {
        let nextStep = document.querySelector('.steps p.inactive');
        let nextCe = document.querySelector('div.inactive');

        if(this.formFields) {
            if(!this.formFields.classList.contains('inactive')) {
                if(!formReady) {
                    return false;
                }
            }
        }
        
        if(nextStep) {
            nextStep.classList.remove('inactive');
        }
        
        if(nextCe) {
            nextCe.classList.remove('inactive');
            if(nextCe.classList.contains('formfields')) {
                this.input.checkFields();
            }
            
            if(nextCe.classList.contains('upsellings')) {
                this.enableNextStep(formReady);
            }

            if(nextCe.classList.contains('paypal')) {
                this.enableNextStep(formReady);
            }
            this.summary.updatePosition();
        }
    };

    checkDeliveryStartBox(drerz) {
        if(drerz == "PREMIUM" || drerz == "BASIS" || drerz == "NEWS" || drerz == "WEB") {
            this.deliveryStartHolder.classList.add('d-none');
            this.deliveryStartFallback.classList.remove('d-none');
            this.deliveryStartTitle.classList.remove('d-none');
        } else if(drerz == "GERAET") {
            this.deliveryStartHolder.classList.add('d-none');
            this.deliveryStartFallback.classList.add('d-none');
            this.deliveryStartTitle.classList.add('d-none');
        } else {
            this.deliveryStartHolder.classList.remove('d-none');
            this.deliveryStartFallback.classList.add('d-none');
            this.deliveryStartTitle.classList.remove('d-none');
        }
    };

    summaryEvents() {
        this.summary.addEventListener('summaryUpdated', () => {
            this.payment.updateReportingPrice();

            let bell = document.querySelector('.update-notice svg');
            if (bell.isVisible()) {
                bell.classList.add('bell-shake');
                setTimeout(() => {
                    bell.classList.remove('bell-shake');
                }, 2000);
            }
        });
    }

    paymentEvents() {
        this.payment.addEventListener('submitLandingpage', () => {
            this.submitLandingpage();
        });
        
        this.payment.addEventListener('updatePosition', () => {
            this.summary.updatePosition();
        });

        this.payment.addEventListener('updatePayment', event => {
            this.summary.updatePayment(event.detail.title);
            if(event.detail.type == 'creditcard') {
                this.payment.initCreditCard();
            }
        });
        
        this.payment.addEventListener('updatePrice', event => {
            this.summary.updatePriceOffer(event.detail.offer);
            this.summary.updatePriceDevice(event.detail.device);
            this.summary.updatePriceSurcharge(event.detail.surcharge);
            this.payment.updateReportingPrice();
        });

        this.payment.addEventListener('updateAusgabe', event => {
            this.pvawidget.update(event.detail);
            this.updatePva();
        });

        this.payment.addEventListener('addressError', event => {
            this.input.updateFieldStatus(event.detail, false, false);
        });

        this.payment.addEventListener('priceLoader', () => {
            this.summary.priceLoader();

            Tracking.customEvent('checkout_form', {
                product_name: 'form',
                event_category: 'checkout',
                event_action: 'form',
                event_label: 'form',
                step: this.getEventStep('form'),
                maxStep: this.maxSteps,
                prefilled: OVS.app.user.isUser,
            });
        });
        
        this.payment.addEventListener('removeLoader', () => {
            this.summary.removeLoader();
        });

        this.payment.addEventListener('updateFaktura', event => {
            this.summary.updateRabat(event.detail);
        });

        this.payment.addEventListener('updateDeliveryDate', event => {
            if (!this.offer.deliveryStart) {
                this.setAboStart(event.detail, false);
            }
        });
    };

    inputEvents() {
        this.input.addEventListener('updateAusgabe', event => {
            this.pvawidget.value = event.detail;
            this.pvawidget.touched = true;
            this.payment.getPrice(this.offer.id, this.bonus.id, this.bonus.variantId, this.pvawidget.touched);
        });

        this.input.addEventListener('updateInput', event => {
            this.summary.updateInput(event.detail.name, event.detail.value);
        });

        this.input.addEventListener('nextStep', () => {
            this.enableNextStep(true);
        });

        this.deliveryStart.addEventListener('change', () => {
            this.deliveryStartTouched = true;
            this.summary.updateDeliveryStart(this.deliveryStart.value);
            this.payment.getPrice(this.offer.id, this.bonus.id, this.bonus.variantId, this.pvawidget.touched);
        });

        this.deliveryStart.addEventListener('onPickerSelect', () => {
            this.deliveryStartTouched = true;
            this.summary.updateDeliveryStart(this.deliveryStart.value);
            this.payment.getPrice(this.offer.id, this.bonus.id, this.bonus.variantId, this.pvawidget.touched);
        });

        this.input.addEventListener('updateAddress', () => {
            this.payment.getPrice(this.offer.id, this.bonus.id, this.bonus.variantId, this.pvawidget.touched);
        });
    };

    productEvents() {
        this.product.addEventListener('selectOffer', event => {
            if(event.detail.offer.isOffer) {
                this.pvawidget.touched = false;
                this.offer = event.detail.offer;
                Cookies.set('ovs_selected_offer', this.offer.id, { expires: 365, secure: false, domain: OVS.app.user.cookieDomain });
                this.summary.updateProduct(this.offer.title, this.offer.runtime);
                
                this.checkDeliveryStartBox(this.offer.drerz);
                this.payment.isFree = this.offer.isFree;
                this.payment.faktura(this.offer.faktura);
                this.payment.offerPrice = this.offer.prices;
                
                if(this.offer.deliveryStart) {
                    this.setAboStart(this.offer.deliveryStart, true);
                }

                this.fixDeliveryStart(this.offer.fixDeliveryStart);

                this.product.changeBonus(this.offer.id);
                this.payment.updatePaymentOptions(this.offer.payments);

                this.payment.getPrice(this.offer.id, this.bonus.id, this.bonus.variantId, this.pvawidget.touched);
                
                this.summary.updateSteps();

                this.offer.trackEvent(this.getEventStep('offer'), this.maxSteps);
            } else {
                this.upsell = event.detail.offer;
                this.payment.upsellPrice = this.upsell.prices[0];
                this.summary.updateProduct(this.offer.title + '<br>' + this.upsell.title, this.offer.runtime);
                this.summary.updateUpselling(this.upsell.prices[0]);
            }
            this.payment.selectFirstPayment();
            this.input.updateFieldStatus('order[product]', true, false);
            this.enableNextStep();
        });
        
        this.product.addEventListener('unselectOffer', event => {
            if(!event.detail.offer.isOffer) {
                this.upsell = false;
                this.payment.resetOffer();
                this.payment.update();
                this.summary.updateProduct(this.offer.title, this.offer.runtime);
                this.summary.updateUpselling(0);
            }
            Cookies.remove('ovs_selected_offer', { expires: 365, secure: false, domain: OVS.app.user.cookieDomain });
        });

        this.product.addEventListener('selectBonus', event => {
            this.bonus = event.detail.bonus;
            this.summary.updateDevice(this.bonus.title, this.bonus.text, this.bonus.category);
            
            this.payment.price.surcharge.bonus = this.bonus.surcharge;
            this.payment.devicePrice = this.bonus.price;
            
            OVS.app.helper.removeClass('.first-step-title', 'd-none');
            
            this.bonus.trackEvent(this.getEventStep('bonus'), this.maxSteps);
            this.enableNextStep();
            
            if(this.addon) {
                if( (!this.bonus.addon) || (this.bonus.addon != this.addon.id) ) {
                    this.addon.unselect();
                }
            }

            if(this.pvawidget.price) {
                this.summary.updatePriceOffer(this.pvawidget.price, true);
            }
            
            if(this.pvawidget.device) {
                this.summary.updatePriceDevice(this.pvawidget.device, true);
            }
        });
        
        this.product.addEventListener('unselectBonus', () => {
            this.bonus = false;
            this.summary.updateDevice()
            this.payment.resetBonus();
            this.payment.update();
        });

        this.product.addEventListener('selectAddon', event => {
            this.addon = event.detail.addon;
            this.summary.updateAddon(this.addon.title, this.addon.surcharge);
            this.payment.price.surcharge.addon = this.addon.surcharge;
            this.payment.setPrice();
            this.addon.trackEvent(this.getEventStep('addon'), this.maxSteps);
        });
        
        this.product.addEventListener('unselectAddon', () => {
            this.addon = false;
            this.summary.updateAddon();
            this.payment.resetAddon();
            this.payment.update();
        });

        this.product.addEventListener('noBonus', () => {
            this.enableNextStep();
            if(this.bonus) {
                this.bonus.unselect();
            }
            this.summary.updateDevice();
            this.summary.updatePriceDevice(false);
            this.summary.updateSteps();
            
            this.product.addons.every(addon => {
                addon.hide();
            });
            
            Tracking.customEvent('checkout_bonus', {
                product_name: 'no bonus available',
                event_category: 'checkout',
                event_action: 'bonus',
                event_label: 'no bonus available',
                step: this.getEventStep('bonus'),
                maxStep: this.maxSteps,
                prefilled: OVS.app.user.isUser,
            });
        });
    };

    setAboStart(value, hasDate = false) {
        let date = (value ? moment(value) : moment());
        if (!this.deliveryStartTouched) {
            let maxDate = (value ? moment(value) : moment());
            maxDate.add(8, 'weeks');
            this.deliveryStart.picker.update({
                'minDate': date,
                'maxDate': maxDate
            });
        }
        
        this.deliveryStart.picker.update({'selectedDates' : date}, {'silent' : true});
        value = hasDate ? date.format("L") : 'sofort';
        
        if (this.deliveryStartFallback.classList.contains('d-none')) {
            value = date.format("L");
        } else {
            date = moment();
            if(this.offer.forerun > 0) {
                date.add(this.offer.forerun, 'days');
            }
            this.deliveryStart.value = date.format("L");
        }
        this.summary.updateDeliveryStart(value);
    };

    fixDeliveryStart(fixed) {
        if (fixed) {
            this.deliveryStart.readOnly = true;
            this.deliveryStart.classList.add('deactive');
        } else {
            this.deliveryStart.readOnly = false;
            this.deliveryStart.classList.remove('deactive');
        }
    };

    getEventStep(box) {
        switch(box) {
            case 'offer': {
                return 1;
            }
            case 'bonus': {
                return 2;
            }
            case 'addon': {
                if(!this.hasBonus)
                    return 2;
                else
                    return 3;
            }
            case 'form': {
                return this.maxSteps - 1;
            }
            case 'submit': {
                return this.maxSteps;
            }
        }
    };

    globalInit() {
        let detailsButton = document.querySelector('.fadeinlink');
        let fadein = document.querySelector('.fadein');
        let fadewhite = document.querySelector('.fadewhite');
        if(detailsButton) {
            detailsButton.addEventListener('click', event => {
                event.preventDefault();
                if(fadein.classList.contains('exposed')) {
                    fadein.classList.remove('exposed');
                    fadewhite.classList.remove('d-none');
                    detailsButton.innerHTML = 'mehr Infos';
                } else {
                    fadein.classList.add('exposed');
                    fadewhite.classList.add('d-none');
                    detailsButton.innerHTML = 'weniger Infos';
                }
                this.summary.updatePosition();
            });
        }
    };
}
